// extracted by mini-css-extract-plugin
module.exports = {"track":"LogoList_track__EyfVF","scroll":"LogoList_scroll__vhdPr"};